/**
 * Created by charnjeetelectrovese@gmail.com on 1/22/2020.
 */
import {formDataRequest, getRequest, postRequest} from "../libs/AxiosService.util";

export async function serviceGetCustomList(list, otherParams = {}) {
    return await postRequest('list/custom', {list: list, ...otherParams});
}

export async function serviceGetKeywords() {
    return await postRequest('keywords', {});
}

export async function serviceGetVendorsList() {
    return await getRequest('/vendors/list');
}

export async function serviceCaptureInfo(params) {
    return await postRequest('capture/info', params);
}

export async function serviceGetList(list, otherParams = {}) {
    return await postRequest('list', { list: list, ...otherParams });
}
export async function serviceGetPendingCounts() {
    return await getRequest('dashboard/pending/counts');
}